import React from "react";
import { Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DARK } from "../../styles/mui-theme";
import { ItemType } from "../../types/types";

interface PublicItemProps {
  item: ItemType;
}

const Name: React.FC<PublicItemProps> = ({ item }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const variant = isSmall ? "h5" : "h4";

  return (
    <Typography variant={variant} fontWeight="bold" color={DARK}>
      {item.name}
    </Typography>
  );
};

export default Name;
